"use client";

import { useEffect } from "react";
import { useStores } from "../../stores/useStores";

const GoogleAnalyticsScript = () => {
  const { organizationStore } = useStores();

  useEffect(() => {
    const google_analytics_id =
      organizationStore.organization.json_data?.settings?.analytics
        ?.google_analytics_id;
    if (google_analytics_id) {
      if (
        !document.querySelector(
          `script[src="https://www.googletagmanager.com/gtag/js?id=${google_analytics_id}"]`,
        )
      ) {
        const googleAnalyticsScript = document.createElement("script");
        googleAnalyticsScript.src =
          "https://www.googletagmanager.com/gtag/js?id=" + google_analytics_id;
        googleAnalyticsScript.async = true;
        const html =
          "window.dataLayer = window.dataLayer || [];" +
          "function gtag(){window.dataLayer.push(arguments)};" +
          "gtag('js', new Date());" +
          "gtag('config', '" +
          google_analytics_id +
          "');";
        const google_script = document.createElement("script");
        google_script.innerHTML = html;
        document.head.appendChild(googleAnalyticsScript);
        document.head.appendChild(google_script);
      }
    }
  }, []);

  return <></>;
};

export default GoogleAnalyticsScript;
